import React, { useEffect } from "react";
import { useState } from "react";

import { makeStyles, styled } from "@material-ui/core/styles";

import LoadingComponent from "../../../../components/Loading";

import { useSelector } from "react-redux";

import { selectUsuarioSeleccionado } from "../../../../redux/reducer/loginReducer";
import EmptyComponent from "../../../../components/EmptyContent";
import TituloPagina from "../../../../components/Titulos/TituloPagina";
import {
  getAlumnosNotasExamenes,
  updateAlumnoNotasExamenesPlaza,
} from "../../../../services/alumnos";
import {
  DataGridPro,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import { Box, Card, CardContent, Checkbox, Grid, IconButton, Paper, Typography } from "@material-ui/core";
import { getTutores } from "../../../../services/tutores";
import { set } from "date-fns";
import { Stack } from "@mui/material";

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
}));

export default function AlumnosDistribucionContent() {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");
  const [tutores, setTutores] = useState([]);

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
  }, []);

  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */
  const Contenido = () => {
    return (
      <>
        <TituloPagina titulo={"Alumnos asignados a tutor"} />

        <CargaAlumnosTutor />
      </>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
      {loading ? (
        <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
      ) : (
        <Contenido />
      )}
    </div>
  );
}

const CargaAlumnosTutor = () => {
    const [loading, setLoading] = useState(false)
    const [tutores, setTutores] = useState([])
    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });

    useEffect(() => {
        setLoading(true)
        
        getTutores({ usuario_id: usuarioSeleccionado.id }).then((response) => {

            response.tutores && setTutores(response.tutores)

            setLoading(false)
        });

    }, [])
    

    // const state = {
          
    //     series: [{
    //       data: tutores.map( (tutor) => tutor.num_alumnos_asignados )
    //     }],
    //     options: {
    //       chart: {
    //         type: 'bar',
    //         height: 750
    //       },
    //       plotOptions: {
    //         bar: {
    //             borderRadius: 4,
    //             barHeight: '100%',
    //             // distributed: true,
    //             horizontal: true,
    //             // dataLabels: {
    //             //     position: 'bottom'
    //             // },
    //         }
    //       },
    //       dataLabels: {
    //         enabled: false
    //       },
    //       xaxis: {
    //         categories: tutores.map( (tutor) => `${tutor.nombre} ${tutor.apellidos}` )
    //       }
    //     },
      
      
    //   };
    

    return (
        <>
            {/* <Grid xs={12} style={{margin: 0, padding: '0 20px'}} spacing={2}>
                <ReactApexChart options={state.options} series={state.series} type="bar" height={750} />
            </Grid> */}
            <Grid container xs={12} style={{margin: 0, padding: '0 20px'}} spacing={2}>
              <Paper elevation={1} style={{width: '100%', padding: 20, marginBottom: 20}}>
                <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                  <Typography component="h3" variant="h5" color="primary">
                      Total Alumnos Asignados: {tutores.reduce( (total, tutor) => total + parseInt(tutor.num_alumnos_asignados), 0)}
                  </Typography>
                  <Typography component="h3" variant="h5" color="primary">
                      Total Tutores: {tutores.length}
                  </Typography>
                  </Stack>
              </Paper>
            </Grid>
            <Grid container xs={12} style={{margin: 0, padding: '0 20px'}} spacing={2}>
                {
                  
                    tutores.map( (tutor) => {
                        if(isNaN(parseInt(tutor.num_max_alumnos))){
                            tutor.num_max_alumnos = 0
                        }
                        const porcentajeOcupacion = tutor.num_max_alumnos > 0 
                          ? Math.round((parseInt(tutor.num_alumnos_asignados) / parseInt(tutor.num_max_alumnos)) * 100) 
                          : 0;

                        return (
                          <Grid item xs={3} style={{ display: 'flex' }}>
                            <Card style={{ width: '100%', display: 'flex', flexDirection: 'column', minHeight: 250 }}>
                              <CardContent style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                <div style={{display: "flex", justifyContent: 'space-between', alignItems: 'center', justifyItems: 'center'}}>
                                  <Typography component="h3" variant="h5" color="primary" style={{height: 65}}>
                                    {tutor.nombre} {tutor.apellidos}
                                  </Typography>
                                  <Typography component="h3" variant="h5" style={{color: porcentajeOcupacion >= 90 ? 'red' : porcentajeOcupacion >= 80 ? 'orange' : 'green', height: 65}}>
                                    {porcentajeOcupacion}%
                                  </Typography>
                                </div> 
                                <div>
                                  {
                                  tutor?.grupos?.map( (grupo, index) => (
                                    <Typography component="h4" variant="h6" style={{color: '#bdbdbd', fontSize: 16}} gutterBottom>
                                    {grupo.es_tutor === "1" && "Tutor: "}
                                    {grupo.es_coordinador === "1" && "Coordinador: "}
                                    {grupo.es_apoyo === "1" && "Apoyo: "}
                                    {grupo.descripcion} 
                                    </Typography>
                                  ))
                                  }
                                </div>
                                {
                                tutor.num_alumnos_asignados === "0" ?
                                
                                <Typography align='right' component="p" variant="h4">
                                  {tutor.num_alumnos_asignados}
                                </Typography>
                                
                                :
                                  
                                  parseInt(tutor.num_alumnos_asignados) >= parseInt(tutor.num_max_alumnos) ?

                                  <Typography align='right' component="p" variant="h4" style={{color: 'red'}}>{parseInt(tutor.num_alumnos_asignados)}/{parseInt(tutor.num_max_alumnos) }</Typography>

                                :

                                  parseInt(tutor.num_max_alumnos) - parseInt(tutor.num_alumnos_asignados) <= 10?

                                  <Typography align='right' component="p" variant="h4" style={{color: 'orange'}}>{parseInt(tutor.num_alumnos_asignados)}/{parseInt(tutor.num_max_alumnos) }</Typography>

                                :
                                  
                                  <Typography align='right' component="p" variant="h4">{parseInt(tutor.num_alumnos_asignados)}/{parseInt(tutor.num_max_alumnos) }</Typography>

                                }

                                <Typography align='right' color="text.secondary">
                                  Alumnos
                                </Typography>
                                
                              </CardContent>
                            </Card>
                          </Grid>
                  
                        )
                    })
                    
                }

            </Grid>
        </>
    )
}
